import { createFileRoute } from '@tanstack/react-router';

import { BillingPage } from '@/features/settings';

export const Route = createFileRoute('/_authenticated/_withWorkspace/settings/billing')({
  component: BillingPage,
});
